const searchInput = document.getElementById('blogSearchInput');
const searchBtn = document.getElementById('blogSearchBtn');
const clearBtn = document.getElementById('blogClearBtn');
const statusDiv = document.getElementById('searchStatus');
const searchContainer = document.getElementById('items-grid-container');
const pagination = document.querySelector(".blog-page-pagination");
const paginationHtml = pagination ? pagination.innerHTML : null
const inLoadUrlParams = new URLSearchParams(window.location.search);
const onLoadQuery = inLoadUrlParams.get('q');
const originalHTML = searchContainer.innerHTML;

if ((onLoadQuery !== null && onLoadQuery.trim() !== '' && searchInput.value == '') || (onLoadQuery !== null && onLoadQuery.trim() !== searchInput.value.trim())) {
  const onLoadPage = inLoadUrlParams.get('page') || null;
  displaySearchResults(onLoadQuery, onLoadPage)
  searchInput.value = onLoadQuery
  clearBtn.classList.remove('hidden')
}

searchInput.addEventListener('keypress', (e) => {
  if (e.key === 'Enter') performSearch();
});

searchBtn.addEventListener('click', performSearch);

clearBtn.addEventListener('click', () => {
  searchInput.value = '';
  window.location.href = window.location.pathname;
});

function performSearch() {
  blogUpdateURLParams('')
  const query = searchInput.value.trim();

  if (!query) {
    statusDiv.textContent = statusDiv.dataset.noTermsText;
    statusDiv.className = 'search-status error';
    return;
  }

  statusDiv.textContent = statusDiv.dataset.searchText;
  statusDiv.className = 'search-status loading';
  searchBtn.disabled = true;

  const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[options][fields]=title,body,author,tag`;

  fetch(searchUrl)
    .then(res => res.json())
    .then(suggestions => {
      const productSuggestions = suggestions.resources.results.articles;

      if (productSuggestions.length > 0) {
        displaySearchResults();
        statusDiv.className = 'search-status success';
      } else {
        statusDiv.textContent = statusDiv.dataset.noResults;
        statusDiv.className = 'search-status';
      }
      clearBtn.classList.remove('hidden')
    })
    .catch(err => {
      console.error('Search error:', err);
      statusDiv.textContent = statusDiv.dataset.error;
      statusDiv.className = 'search-status error';
    })
    .finally(() => {
      searchBtn.disabled = false;
    });
};

function handleClickOnDynamicAnchor(e) {
  const query = searchInput.value.trim();
  
  if (!query) {
    return;
  }
  
  e.preventDefault();
  const target = e.target.closest('a')
  const url = new URL(target.href);
  let assignedPage = url.searchParams.get('page') || '1';
  displaySearchResults(query, assignedPage)
}

function handleNewlyRenderedPagination() {
  const newlyRenderedPaginationItems = document.querySelectorAll('.blog-page-pagination li')
  newlyRenderedPaginationItems.forEach((indicator) => {
    const nestedAnhor = indicator.querySelector('a')
    if (nestedAnhor) {
      nestedAnhor.removeAttribute('@click')
      nestedAnhor.addEventListener('click', (e) => handleClickOnDynamicAnchor(e))
    }
  })
}

function blogUpdateURLParams(params) {
  const url = new URL(window.location);
  
  if (params) {
    const newParams = new URLSearchParams(params);
    for (const [key, value] of newParams) {
      url.searchParams.set(key, value);
    }
  } else {
    url.search = '';
  }

  window.history.replaceState({}, '', url)
}

async function displaySearchResults(customQuery = false, page = null) {
  let query = customQuery || encodeURIComponent(searchInput.value.trim());

  if (!query) return

  if (window.location.pathname.includes('tagged')) {
    const tag = window.location.pathname.split('/').pop();
    if (!query.includes(`+${tag}`)) query += `+${encodeURIComponent(tag)}`;
  }
  
  const currentUrl = new URL(window.location);
  currentUrl.searchParams.set('q', query);
  
  if (page && page !== '1') {
    currentUrl.searchParams.set('page', page);
  } else {
    currentUrl.searchParams.delete('page');
  }
  
  window.history.replaceState({}, '', currentUrl);

  const sectionId = document.querySelector(".blog-section-root").dataset.sectionId
  let fetchUrl = `/search?sections=${sectionId}&type=article&options[prefix]=none&q=${query}`;
  if (page && page !== '1') {
    fetchUrl += `&page=${page}`;
  }
  const res = await fetch(fetchUrl, { headers: { 'Accept': 'application/json' } });
  if (!res.ok) return;

  const json = await res.json();
  const parser = new DOMParser();
  const pageHtml = json[sectionId]
  const doc = parser.parseFromString(pageHtml, 'text/html');
  const articlesGrid = doc.querySelector("#items-grid-container")

  if (articlesGrid) {
    statusDiv.classList.add('hidden')
    searchContainer.innerHTML = articlesGrid.innerHTML;
    handleNewlyRenderedPagination()
    
    const blogSection = document.querySelector('.blog-section-root');
    if (blogSection) {
      blogSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
